import { useState, useEffect, useRef } from 'react';
import cn from 'classnames';

import {
  addDays,
  isSameDay,
  eachDayOfInterval,
  intervalToDuration
} from 'date-fns'

import dayjs from 'dayjs'

import {
  Modal,
} from 'rsuite'


import Select from './Select';
import RentalDuration from './RentalDuration';
import CalendarWithInput from './CalendarWithInput';
import Divider from './Divider';
import Button from './Button';
import CloseButton from './CloseButton';
import Delivery from './Delivery';

import {
  getStockByDates,
  mergeStocksByDates,
  getDurationOptions,
  adjustStockForDuration,
} from './availability'
import { API_HOST } from './utils';
import useOnClickOutside from './hooks';
import { DEFAULT_BUFFER_DAYS } from './constants';

import { eventLog } from './api'

import './RentalModal.css';
import './Modal.css';

const RentalModal = (props) => {
  const { show, onHide, onApply, cartData, productData, dateRange: rentalDateRange,
    disabled, isDesktop, isMobile, onChangeDayDelivery, onSetPostcode, isActiveDayDelivery, areaPostcode,
    isPickUp, sameDayDeliveryAvailable } = props;
  const [ rentalDurationArray, setRentalDurationArray ] = useState([])
  const [ rentalDuration, setRentalDuration ] = useState(0)
  const [ dateRange, setDateRange ] = useState([
      addDays(new Date(), DEFAULT_BUFFER_DAYS),
      addDays(new Date(),  DEFAULT_BUFFER_DAYS + 1)]
  );
  const [ openCalendar, setOpenCalendar ] = useState(false);
  const [ error, setError ] = useState(null);

  const [ currentSku, setCurrentSku ] = useState(null)
  const [ showSameDayDeliveryCheckbox, setShowSameDayDeliveryCheckbox] = useState(true);

  const jsonRentalData = localStorage.getItem('rentalData')
  const rentalData = jsonRentalData ? JSON.parse(jsonRentalData) : null

  const isProductModal = show === 'product';

  const errorRef = useRef();

  useEffect(() => {
    let currentSKU = productData.skus[0]
    // if (isProductModal && productData) {
    //   currentSKU = productData.skus[0]
    // } else if (!isProductModal && cartData && cartData.skus.length) {
    //   currentSKU = cartData.skus[0]
    // }

    if (!currentSKU) {
      // console.log('Rntr: SKU for popup not found')
      return
    }

    setCurrentSku(currentSKU)

    if(sameDayDeliveryAvailable) {
      currentSKU.daysBeforeRent && setShowSameDayDeliveryCheckbox(false);
    } else {
      setShowSameDayDeliveryCheckbox(false);
    }

    const durationOptions = getDurationOptions(currentSKU)
    setRentalDurationArray(durationOptions);

    if (durationOptions.length === 0) {
      return
    }

    let rentalInterval = 0

    // if(rentalDateRange) {
    //   const { dateFrom, dateTo } = rentalDateRange;
    //   const interval = intervalToDuration({ start: new Date(dateFrom), end: new Date(dateTo) })
    //   rentalInterval = interval.days + 1;
    //   setDateRange([new Date(dateFrom), new Date(dateTo)])
    // } else
    // {
      rentalInterval = durationOptions[0].value;
      const newBufferDays = currentSKU.daysBeforeRent ? currentSKU.daysBeforeRent : DEFAULT_BUFFER_DAYS;
      const newDateRange = calcDateRange(currentSKU, rentalInterval, isActiveDayDelivery, newBufferDays)
      setDateRange(newDateRange)
    // }
    setRentalDuration(rentalInterval)
  }, [show])


  useOnClickOutside(errorRef, () => {
    setError(null)
  });

  const calcDateRange = (sku, rentalInterval, isSameDay=false, safeDays=DEFAULT_BUFFER_DAYS) => {
    let newDateRange = [addDays(new Date(), safeDays), addDays(new Date(), safeDays + rentalInterval - 1)]

    if (!productData.skuAvs || productData.skuAvs.length === 0) {
      return newDateRange
    }

    const relevantAvs = productData.skuAvs.filter(item => sku.strId === item.skuStrId);
    const disabledDates = getStockByDates(relevantAvs)
    adjustStockForDuration(disabledDates, rentalInterval, isSameDay, safeDays)

    let dateStr = dayjs().format('YYYY-MM-DD');
    const lastDate = Object.keys(disabledDates)[Object.keys(disabledDates).length - 1]
    let freeDays = 0;
    let endFreeDaysIntervalDate = null


    while(dateStr <= lastDate) {
      if(disabledDates[dateStr] > 0) {
        freeDays++;
      } else {
        freeDays = 0;
      }

      if(rentalInterval === freeDays) {
        endFreeDaysIntervalDate = dayjs(dateStr)
        break;
      }

      const nextDate = dayjs(dateStr).add(1, 'day');
      dateStr = nextDate.format('YYYY-MM-DD')
    }

    if(endFreeDaysIntervalDate) {
      newDateRange = [new Date(endFreeDaysIntervalDate.subtract(rentalInterval - 1, 'day')),new Date(endFreeDaysIntervalDate)]
    }
    return newDateRange
  }

  const handleChangeDayDelivery = (isActive) => {
    // console.log({isActive})
    const newDateRange = calcDateRange(currentSku, rentalDuration, isActive)
    // console.log({newDateRange})
    setDateRange(newDateRange)
    onChangeDayDelivery(isActive)

    eventLog({event_id: 13});
  }

  const handleChange = (value) => {
    setRentalDuration(value);

    setDateRange([ dateRange[0], addDays(dateRange[0], value - 1) ]);

    setOpenCalendar(true);

    eventLog({event_id: 12});
  }

  const handleApply = () => {
    const data = {
      rental: rentalDurationArray.find(item => item.value === rentalDuration),
      dateRange
    }

    if(isProductModal) {
      const skus = rentalData ? rentalData.skus : [];
      const skuIndex = skus.findIndex(item => item.strId === currentSku.strId)

      if(skuIndex === -1) {
        data.skus = [ ...skus, currentSku ]
      } else {
        data.skus = skus
      }

      data.currentSku = currentSku;
    }
    // console.log('@ApplyData', data)

    if(isActiveDayDelivery && !areaPostcode && !isPickUp) {
      setError('You choosed Same day delivery. Please, enter Sydney Metro postcode')
      return;
    }

    onApply(data)
    setRentalDuration(0)
    setRentalDurationArray([])
  }

  const handleChangeDate = (dates) => {
    const { dateFrom, dateTo } = dates;
    const newDateRange = [dateFrom, dateTo];
    setDateRange(newDateRange)
  }

  const handleChangeColor = (skuStrId) => {
    const skuItem = productData.skus.find(item => item.strId === skuStrId)
    setCurrentSku(skuItem)

    const showCheckbox = !skuItem.daysBeforeRent
    setShowSameDayDeliveryCheckbox(showCheckbox);

    const newBufferDays = skuItem.daysBeforeRent ? skuItem.daysBeforeRent : DEFAULT_BUFFER_DAYS;
    const newDateRange = calcDateRange(skuItem, rentalDuration, isActiveDayDelivery, newBufferDays)
    setDateRange(newDateRange)
    setOpenCalendar(true)
  }

  const handleChangeSize = skuStrId => {
    const skuItem = productData.skus.find(item => item.strId === skuStrId);

    setCurrentSku(skuItem);

    eventLog({event_id: 11});
  }

  const hasSizeOptions = productData.skus.some(sku => sku.size);
  const hasColorOptions = productData.skus.some(sku => sku.color);
  const modalClasses = cn('rntr-root-popup', { 'rntr-root-popup_same-day-delivery': isActiveDayDelivery })

  return (
      <Modal className={ modalClasses } classPrefix='rntr-modal' show={ Boolean(show) } onHide={ onHide } overflow={ false }>
      <CloseButton onHide={ onHide } className='rntr-rental__close'/>
      <div className='rntr-rental__body'>
        <div className='rntr-rental__grid'>
          <div className='rntr-rental__top'>
            <div className='rntr-rental__img-wrapper'>
              {
                productData && productData.product && productData.product.images[0] &&
                <img
                  className='rntr-rental__img'
                  src={`${API_HOST}/api/media/${productData.product.images[0]}`}
                  alt={productData.product.title} />
              }
            </div>
            {
              isMobile &&
              <div className='rntr-rental__selects'>
                { hasSizeOptions &&
                  <Select
                    skus={productData.skus}
                    label='size'
                    type='size'
                    sku={ currentSku }
                    placeholder='Select size'
                    onChange={handleChangeSize}/>
                }
                { hasColorOptions &&
                  <Select
                    skus={productData.skus}
                    label='color'
                    type='color'
                    placeholder='Select color'
                    sku={ currentSku }
                    onChange={handleChangeColor}/>
                }
              </div>
            }
            {isDesktop &&
              <div className='rntr-rental__title'>
                { productData.product.title }
              </div>
            }
          </div>
          <div className='rntr-rental__controls'>
            { (showSameDayDeliveryCheckbox || isPickUp) &&
                <>
                  <div className='rntr-rental__delivery'>
                    <Delivery
                        showSameDayDeliveryCheckbox={ showSameDayDeliveryCheckbox }
                        onChangeDayDelivery={ handleChangeDayDelivery }
                        onSetPostcode={ onSetPostcode }
                        isActiveDayDelivery={ isActiveDayDelivery }
                        isPickUp={ isPickUp }/>
                  </div>
                  <Divider />
                </>
            }
            <RentalDuration
              rentalDurationArray={rentalDurationArray}
              onChange={handleChange}
              rentalDuration={rentalDuration}/>
            {isDesktop && <Divider />}
          </div>
        </div>
        {!isMobile && !isDesktop && <Divider />}
        <div className='rntr-rental__middle'>
          {
            !isMobile &&
            <div className='rntr-rental__selects'>
              { hasSizeOptions &&
                <Select
                  skus={productData.skus}
                  label='size'
                  type='size'
                  sku={ currentSku }
                  placeholder='Select size'
                  onChange={handleChangeSize}/>
              }
              { hasColorOptions &&
                <Select
                  skus={productData.skus}
                  label='color'
                  type='color'
                  placeholder='Select color'
                  sku={ currentSku }
                  onChange={handleChangeColor}/>
              }
            </div>
            }
          <div className='rntr-rental__calendars'>
            <div className='rntr-rental__calendar'>
              <CalendarWithInput
                label='Start date'
                cartData={ cartData }
                dateRange={ dateRange }
                onChangeDate={ handleChangeDate }
                productData={ productData }
                productSku={ currentSku }
                rentalDuration={ rentalDuration }
                openCalendar={ openCalendar }
                setOpenCalendar={ setOpenCalendar }
                isActiveDayDelivery={ isActiveDayDelivery }
                isDesktop={ isDesktop }
                show='product'/>
            </div>
            <div className='rntr-rental__calendar'>
              <CalendarWithInput
                label='Return date'
                disabled
                isActiveDayDelivery={ isActiveDayDelivery }
                productSku={ currentSku }
                dateRange={ dateRange }
                />
            </div>
          </div>
        </div>
      </div>
      { !isMobile && <Divider />}

      <div className='rntr-rental__footer'>
        <Button
          onClick={ onHide }
          className='rntr-button_transparent rntr-rental__button'>
          Cancel
        </Button>
        <Button
          onClick={ handleApply }
          className='rntr-button_black rntr-rental__button'
          type='submit'
          disabled={ disabled }>
          Apply
        </Button>
      </div>
      {error &&
        <div ref={ errorRef } className='rntr-rental__error'>{ error }</div>}
    </Modal>
  );
}

export default RentalModal